export default [
    {
        caption: '图片',
        id: 'image',
        items: [
            {
                name: 'Image to Base64',
                id: '1',
                url: 'https://www.css-js.com/tools/base64.html',
                describe: '',
            }, {
                name: '二维码生成',
                id: '2',
                url: 'https://cli.im/text',
                describe: '',
            }, {
                name: '高清素材图下载',
                id: '3',
                url: 'https://pixabay.com/',
                describe: '',
            },
        ]
    }, {
        caption: 'Icon',
        id: 'icon',
        items: [
            {
                name: 'Png to Ico',
                id: '1',
                url: 'http://www.easyicon.net/covert/',
                describe: '',
            }, {
                name: '矢量图标文件生成',
                id: '2',
                url: 'https://icomoon.io/app/#/select',
                describe: '',
            }, {
                name: 'Icon 搜索',
                id: '3',
                url: 'http://www.iconarchive.com/',
                describe: '',
            }, {
                name: '跨平台 Favicon 生成',
                id: '4',
                url: 'https://realfavicongenerator.net/',
                describe: '',
            },
        ]
    }, {
        caption: 'Emoji',
        id: 'emoji',
        items: [
            {
                name: 'Emoji 官网',
                id: '1',
                url: 'https://emojipedia.org/',
                describe: '',
            }, {
                name: 'Emoji 搜索',
                id: '2',
                url: 'http://emoji.muan.co/#',
                describe: '',
            },
        ]
    }, {
        caption: '字体',
        id: 'font',
        items: [
            {
                name: 'Google Fonts',
                id: '1',
                url: 'https://fonts.google.com/',
                describe: '',
            },
        ]
    }
]
